<div class="wrapper">

  <div class="topbar campaign clearfix">
    <div class="logo-picto">
      <a routerLink="/">
        <img class="logo-picto" src="assets/layout/images/logo-picto.png" alt="" srcset="assets/layout/images/logo-picto@2x.png 2x, assets/layout/images/logo-picto@3x.png 3x" />
      </a>
    </div>
    <div id="topbar-icons" class="animated">
      <span class="topbar-search">
        <h1>{{ campaign?.name }}</h1>
      </span>
      <div class="icon-right">
        <a routerLink="/support" target="_blank">
          <span class="topbar-campaign-icon fa fa-life-ring animated swing"></span>
          <span class="topbar-campaign-item-text">{{ 'campaign.support' | translate }}</span>
        </a>
        <button pButton type="button" class="SaveExit" label="{{ 'campaign.exitButton' | translate }}" routerLink="/campaign-list"></button>
      </div>
    </div>
  </div>

  <div class="campaignstatus clearfix">
    <div class="ui-g ui-fluid">
      <div class="ui-g-6">
        <div class="status-left">
          {{'campaign.liveEvaluation' | translate }}
        </div>
      </div>
      <div class="ui-g-6">
        <div class="status-right">
          {{ 'campaign.campaignStatus' | translate }}: <span class="status-live">Live</span>
        </div>
      </div>
    </div>
  </div>

  <div class="campaigninfo">
    <div class="ui-g ui-fluid">
      <div class="ui-g-3">
        <h2>{{ 'campaign.progress' | translate }}</h2>
      </div>
      <div class="ui-g-6 progress">
        <div class="ui-g-10 ui-g-nopad">
          <p-progressBar [value]="percentage" [showValue]="false"></p-progressBar>
        </div>
        <div class="ui-g-2 ui-g-nopad">
          <div class="percentage">{{ percentage }}%</div>
        </div>
      </div>
      <div class="ui-g-3 remaining">
        <div>{{ 'campaign.rDays' | translate }}</div>
        <div class="days">{{ remainingDays }}</div>
      </div>
    </div>
  </div>

  <div class="campaigncharts">
    <div class="ui-g ui-fluid">
      <div class="ui-g-6 ui-g-nopad left-chart">
        <h2>{{ 'campaign.estimatedVsActual' | translate }}</h2>
        <div class="chart-container">
          <button pButton type="button" class="roundedButton slim border status status-all" [class.active]="visibleSerie == 'emission'" label="{{ 'campaign.emission' | translate }}" (click)="updateSeries('emission')"></button>
          <button pButton type="button" class="roundedButton slim border status status-all" [class.active]="visibleSerie == 'redemption'" label="{{ 'campaign.redemption' | translate }}" (click)="updateSeries('redemption')"></button>
          <chart [options]="charts.emissionRedemption.options" (load)="chartInstance(charts.emissionRedemption, $event.context)"></chart>
        </div>
      </div>
      <div class="ui-g-6 ui-g-nopad right-chart">
        <h2>{{ 'campaign.budgetPerType' | translate }}</h2>
        <div class="chart-container">
          <chart [options]="charts.budgetPerType.options" (load)="chartInstance(charts.budgetPerType, $event.context)"></chart>
        </div>
      </div>
    </div>
  </div>

</div>




// WEBPACK FOOTER //
// ./src/app/views/campaign/live-evaluation/live-evaluation.component.html